import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';
import { useSettingsDivision } from 'components/settings/SettingsDivisionContext';
import { SCHEDULING_COLOR_OPTIONS, SCHEDULING_GLOSSY_COLOR_OPTIONS } from '../../scheduling/schedulingConstants';

// Rename the name of the function:
const JobTypeForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    // Prefill the division with the division selected in the settings menu
    const { selectedDivision, isEnvironmentSelected } = useSettingsDivision();
    const divisionDefaultValue = !isEnvironmentSelected && selectedDivision ? { value: String(selectedDivision.id) } : undefined;

    const apiObject = 'workflow'

    const linkedItem = { connected_feature: 'job' }

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'workflow.general.name_label',
            type: 'text',
            placeholder: 'job.job_type.general.name_placeholder',
            width: '50%',
            group: 'field-row-1',
        },
        {
            type: 'dropdown', 
            name: 'connected_feature', 
            label: 'workflow.general.connected_feature_label', 
            disabled_selected: 'forms.select_type_disabled_selected',
            dependentOn: { fieldName: '', value: [''] }, // Hacky solution to hide field in the form
            defaultValue: { value: 'job'},
            allowNoneOption: false,
            showSearch: false,
            width: '50%',
            group: 'field-row-2',
            hardcodedOptions: ([
                { value: 'job', name: 'workflow.connected_feature.job', requiredFeature: 'jobs' },
            ]),
        },
        {
            name: 'color',
            label: 'workflow.general.color_label',
            tooltipText: 'workflow.general.color_tooltip',
            type: 'tabs',
            showIconOnly: true,
            customClass: 'label',
            options: SCHEDULING_COLOR_OPTIONS,
            secondaryOptions: SCHEDULING_GLOSSY_COLOR_OPTIONS,
            width: '50%',
        },
        {
            name: 'division',
            defaultValue: divisionDefaultValue,
            label: 'workflow.general.division_label',
            type: 'dropdown',
            disabled_selected: 'workflow.general.division_disabled_selected',
            showSearch: false,
            apiRequest: [{
                endpoint: 'get_division_list',
                object: 'division',
                params: { is_active: true },
                useCache: true
            }],
            allowNoneOption: false,
            activeFeature: 'divisions',
            width: '50%',
            group: 'field-row-3',
        },
        {
            name: 'is_default',
            label: 'workflow.general.is_default_label',
            type: 'checkbox',
            width: '50%',
            group: 'field-row-4',
        },

        // Job type details
        {
            type: 'divider',
        },
        {
            type: 'header',
            header: 'workflow.general.job_settings_header',
        },
        { 
            type: 'dropdown', 
            name: 'job_default_hourly_rate', 
            label: 'workflow.general.job_default_hourly_rate',
            tooltipText: 'workflow.general.job_default_hourly_rate_tooltipText',
            apiRequest: [{
                endpoint: 'get_hourlyrate_list',
                object: 'hourlyrate',
                params: { is_active: true },
                useCache: true
            }],
            disabled_selected: 'forms.select_type_disabled_selected',
            allowNoneOption: true,
            showSearch: false,
            optionFormat: 'description_and_rate',
            selectionFormat: 'description_and_rate',
            group: 'field-row-4',
            width: '33%',
        },

        // Default tasks
        {
            type: 'job-workflow-default-tasks',
            name: 'default_tasks',
            label: 'workflow.general.default_tasks_header',
            activeFeature: 'job_type_defaults',
            apiRequest: [{
                endpoint: 'get_form_list',
                object: 'form',
                params: { deleted: false },
                useCache: true
            }],
        },

        // Default articles
        {
            type: 'job-workflow-default-items',
            name: 'default_items',
            label: 'workflow.general.default_items_header',
            tooltipText: 'workflow.general.default_items_helper_text',
            activeFeature: 'job_type_defaults',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
        />
    );
};

export default JobTypeForm;